import { pipe } from 'fp-ts/lib/function'
import { POApi } from '../POApi'
import * as t from 'io-ts'
import { ZIO } from '@mxt/zio'
import { Maybe } from '@mxt/zio/codec'
export namespace CancelRiderFromInceptionService {
  export const CustomerReceiveDateOfRiderResponse = t.type({
    lifeNo: t.string,
    riderNo: t.string,
    coverageNo: t.string,
    coverageCode: t.string,
    customerReceivedDate: t.string,
    tf57TransactionDate: t.string
  })

  export const riderInfoRequest = t.type({
    clientNumber: t.string,
    lifeNo: t.string,
    riderNo: t.string,
    coverageNo: t.string,
    coverageCode: t.string,
  })

  export const RiderRefundAmountRequest = t.type({
    body: t.type({
      contractNumber: t.string,
      riderInfos: t.array(riderInfoRequest)
    })
  })
  export const RiderRefundAmountResponse = t.type({
    body: t.type({
      total: Maybe(t.number),
      status: Maybe(t.string),
      riderInfos: Maybe(t.array(t.type({
        lifeNo: t.string,
        riderNo: t.string,
        coverageNo: t.string,
        coverageCode: t.string,
      }))),
      oErrorResult: Maybe(t.type({
        errorCode: t.string,
        errorDescription: t.string
      }))
    })
  })
  export const EffectiveDateDropRider = t.type({
    body: t.type({
      effectiveDropRiderDate: t.string
    })
  })
  export type EffectiveDateDropRider = t.TypeOf<typeof EffectiveDateDropRider>
  export type CustomerReceiveDateOfRiderResponse = t.TypeOf<typeof CustomerReceiveDateOfRiderResponse>
  export type RiderRefundAmountRequest = t.TypeOf<typeof RiderRefundAmountRequest>
  export type RiderRefundAmountResponse = t.TypeOf<typeof RiderRefundAmountResponse>
  export type RiderInfoRequest = t.TypeOf<typeof riderInfoRequest>
  export const getCustomerReceivedDateOfRider = (policyNumber: string) => pipe(
    POApi.get(`wf-api/rider/customer-received-date/${policyNumber}`)(t.type({
      body: t.array(CustomerReceiveDateOfRiderResponse)
    })),
    ZIO.map((responseData) => {
      return responseData.body
    })
  )

  export const getRiderRefundAmount = (bodyData: RiderRefundAmountRequest) => pipe(
    POApi.post(`wf-api/rider/cfi-enquiry`)(RiderRefundAmountResponse)(bodyData)
  )

  export const getEffectiveDateDropRiderOfProduct = (policyNumber: string) => pipe(
    POApi.get(`wf-api/rider/effective-drop-date/${policyNumber}`)(EffectiveDateDropRider),
    ZIO.map((responseData) => {
      const effectiveDropRiderDate = responseData.body.effectiveDropRiderDate
      return effectiveDropRiderDate
    })
  )
}